import { PROGRAM_LOCAL_STATE } from '@resources/lms-management/program-lokal/types'
import { PROGRAM_STATE } from '@resources/lms-management/program/types'

export const APPROVAL_STATUS = {
  PENDING: 'PENDING',
  ADMIN_APPROVED: 'ADMIN_APPROVED',
  ADMIN_REJECTED: 'ADMIN_REJECTED',
} as const

export type ApprovalStatus = keyof typeof APPROVAL_STATUS

export type CalonPesertaDidikResponse = {
  id: string
  program: {
    id: string
    name: string
  }
  programLocal?: {
    id: string
    name: string
  }
  nama: string
  email: string
  provinsi: string
  kotaKabupaten: string
  kecamatan: string
  npsn: string
  namaSekolah: string
  approvalStatus: 'PENDING' | 'ADMIN_APPROVED' | 'ADMIN_REJECTED'
  isSelfEnrollment?: boolean
  isQuotaFull?: boolean
  mataPelajaran: string
  phone: string
  fileUrl?: string
  rejectReason?: string
}

export type CalonPesertaDidikRequest = {
  programId: string
  programLocalId?: string
  peserta: {
    nama: string
    email: string
    nuptk: string
  }[]
  approvalStatus?: string
  kodeProvinsi?: string
  kodeKotaKab?: string
  kodeKecamatan?: string
  email?: string
  npsn?: string
}

export type DiklatProgramLocal = {
  programId: string
  id: string
  name: string
  participantNumber: number
  provinsi: string
  kotaKab: string
  kecamatan: string
  status: PROGRAM_LOCAL_STATE
}

export type AdminPendaftaran = {
  id: string
  nama: string
  email: string
  userId: string
  npsn: string
  namaSekolah: string
  provinsi: string
  kotaKabupaten: string
  kecamatan: string
  assignedPrograms?: {
    id: string
    name: string
  }[]
  assignedProgramLocals?: {
    id: string
    name: string
  }[]
}

export type Candidate = {
  key: React.Key
  nama: string
  email: string
  nuptk: string
  phone: string
  registered: boolean
}

export type DiklatProgram = {
  id: string
  name: string
  startDate: string
  endDate: string
  status: PROGRAM_STATE
  pendaftaranStartDate?: string
  pendaftaranEndDate?: string
  statusProgramLocal: { status: PROGRAM_LOCAL_STATE; count: number }[]
}

export const SUMBER_DATA_DIKLAT = {
  DAPODIK: 'DAPODIK',
  SIMTENDIK: 'SIMTENDIK',
} as const

export type SumberDataDiklat = keyof typeof SUMBER_DATA_DIKLAT
